<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="fullscreenBtn">
    <svg v-if="fullscreen" @click="exitFullscreen()" width="34px" height="34px" viewBox="0 0 60 60"
         version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         xml:space="preserve" xmlns:serif="http://www.serif.com/"
         style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
    <g id="Group-2">
        <path id="Rectangle"
              d="M60,30C60,13.443 46.557,0 30,0C13.443,0 0,13.443 0,30C0,46.557 13.443,60 30,60C46.557,60 60,46.557 60,30Z"
              style="fill:rgb(0,0,0); fill-opacity:0.5;"/>
      <g id="Forward--small-" serif:id="Forward (small)"
         transform="matrix(0.362101,0.362101,-0.362101,0.362101,-6.11211,-163.626)">
            <path d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                  style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
        </g>
      <g id="Forward--small-1" serif:id="Forward (small)"
         transform="matrix(-0.362101,-0.362101,0.362101,-0.362101,66.1121,223.626)">
            <path d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                  style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
        </g>
      <g id="Forward--small-2" serif:id="Forward (small)"
         transform="matrix(0.362101,-0.362101,0.362101,0.362101,-163.626,66.1121)">
            <path d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                  style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
        </g>
      <g id="Forward--small-3" serif:id="Forward (small)"
         transform="matrix(-0.362101,0.362101,-0.362101,-0.362101,223.626,-6.11211)">
            <path d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                  style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
        </g>
    </g>
    </svg>
    <svg v-if="!fullscreen" @click="toggleFullscreen()" width="34px" height="34px"
         viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
         xmlns:serif="http://www.serif.com/"
         style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
      <g id="Group-2">
          <path id="Rectangle"
                d="M60,30C60,13.443 46.557,0 30,0C13.443,0 0,13.443 0,30C0,46.557 13.443,60 30,60C46.557,60 60,46.557 60,30Z"
                style="fill:rgb(0,0,0); fill-opacity:0.5;"/>
        <g id="Forward--small-" serif:id="Forward (small)"
           transform="matrix(-0.362101,-0.362101,0.362101,-0.362101,52.6206,210.135)">
              <path
                d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
          </g>
        <g id="Forward--small-1" serif:id="Forward (small)"
           transform="matrix(0.362101,0.362101,-0.362101,0.362101,7.37936,-150.135)">
              <path
                d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
          </g>
        <g id="Forward--small-2" serif:id="Forward (small)"
           transform="matrix(-0.362101,0.362101,-0.362101,-0.362101,210.135,7.37936)">
              <path
                d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
          </g>
        <g id="Forward--small-3" serif:id="Forward (small)"
           transform="matrix(0.362101,-0.362101,0.362101,0.362101,-150.135,52.6206)">
              <path
                d="M311.2,217.5L300,206.5L300,213L286,213L286,222L300,222L300,228.5L311.2,217.5Z"
                style="fill:white;fill-opacity:0.984314;fill-rule:nonzero;"/>
          </g>
      </g>
    </svg>
  </div>
</template>
<script lang="js">
import { mapState } from 'vuex';

export default {
  data() {
    return {
      fullscreen: false,
    };
  },
  methods: {
    toggleFullscreen() {
      if (!this.fullscreen) {
        this.$fullscreen.toggle(document.querySelector('.videoContainer'), {
          wrap: true,
          callback: () => {
            this.fullscreen = !this.fullscreen;
          },
        });
        window.ga('tok.send', 'event', 'Main Embedded Video', 'Video Fullscreen', this.home.embedded_video.video_id);
      }
    },
    exitFullscreen() {
      this.$fullscreen.exit();
    },
  },
  computed: {
    ...mapState(['home']),
  },
};
</script>
